<template>
    <div id="app" class="link">
        <!-- <configuratoreV1/> -->
        <configuratoreV2/>
        
        <!-- <hr>
        <dev-tool :consumo="1000" :potenza="5" regione="Lombardia" /> -->
    </div>
</template>

<script>
    // import configuratoreV1 from './components/Configuratore/App.vue';
    import configuratoreV2 from './components/Configuratore.2.0/App.vue';
    import devTool from './components/DevTool.vue';

    export default {
        name: 'App',
        components: {
            //configuratoreV1,
            configuratoreV2,
            devTool
        }
    }
</script>

<style>

</style>
